import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductReview } from '../../../common/generated-types';

@Component({
  selector: 'vsf-product-review-card',
  templateUrl: './product-review-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductReviewCardComponent {
  @Input() review: ProductReview;
}